import { Slide } from "@jelly/lesson";
import theory from "../../theory";

import * as hz50 from "./components/50-hz";
import * as hz100 from "./components/100-hz";
import * as hz200 from "./components/200-hz";
import * as hz400 from "./components/400-hz";
import * as hz800 from "./components/800-hz";
import * as hz1600 from "./components/1600-hz";
import * as hz3200 from "./components/3200-hz";

const principle: Slide = {
  description:
    "A plane wave, propagating from left to right, encounters an obstacle: a cylinder of radius a = 20 cm (infinitely long out of the plane). Part of the incident wave is scattered by the obstacle. Look how the scattered and incident waves interfere, hence changing the pressure field distribution. The way phenomena depend on the frequency is of particular interest! Note that 0 dB is the pressure level of the incident plane wave and +6 dB is the maximum pressure level achievable for the plane wave reflecting on a rigid boundary.",
  theory: theory,
  layout: {
    type: "table",
    options: {
      cols: 1,
      rows: 2,
      rowsSize: [1, 9],
      components: [
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "text",
                options: {
                  data: "Cylinder",
                  scrollbars: false,
                  styles: {
                    textAlign: "center",
                    fontSize: "14px",
                    lineHeight: "22px",
                    fontWeight: 800,
                    letterSpacing: "0.25em",
                    textTransform: "uppercase",
                  },
                },
              },
            },
          },
        ],
        [
          {
            variant: "layout",
            data: {
              type: "controlsToggleExtraContent",
              options: {
                controls: [
                  {
                    type: "dropdown",
                    options: {
                      label: "Frequency",
                      labelPosition: "left",
                    },
                    items: [
                      { name: "50 Hz" },
                      { name: "100 Hz" },
                      { name: "200 Hz" },
                      { name: "400 Hz" },
                      { name: "800 Hz" },
                      { name: "1600 Hz" },
                      { name: "3200 Hz" },
                    ],
                  },
                ],
                extraContent: [
                  hz50.extraContent,
                  hz100.extraContent,
                  hz200.extraContent,
                  hz400.extraContent,
                  hz800.extraContent,
                  hz1600.extraContent,
                  hz3200.extraContent,
                ],
                components: [
                  hz50.components,
                  hz100.components,
                  hz200.components,
                  hz400.components,
                  hz800.components,
                  hz1600.components,
                  hz3200.components,
                ],
              },
            },
          },
        ],
      ],
    },
  },
};

export default principle;
